import React, { useEffect, useState } from "react";
import { items, slotsArray } from "../../calendar/data";
import Select from "react-select";
import ReactSelect from "react-select";
import {
    videoUplodeLink,
    createAppointmentAdmin,
    getClientMediumTimeZone,
} from "../../../../services/admin";
import { da } from "date-fns/locale";
import './style.css';
import { toast } from "react-toastify";
import { getTimeImage } from "../../../../utils/utils";
import { setLoading } from "../../../../reducer/auth/auth";
import { useDispatch } from "react-redux";
import { use } from "react";

export default function UpdateVideo({
    updateItem,
    setUpdateItem,
    getAppointmentsNewList,
    handleVideoLinkChange,

}) {
    const dispatch = useDispatch();
    const [appointmentType, setAppointmentType] = useState("");
    const [is_survey, setis_survey] = useState();
    const [userResponsible, setUserResponsible] = useState('');
    const [textValue, setTextValue] = useState("");

useEffect(() => {
    console.log(updateItem, "updateItem in update video");
        if (updateItem) {
            
            setTextValue(updateItem.video_link ? updateItem.video_link : "");
            console.log(updateItem, "updateItem in update video");
        }
    }, [updateItem]);

    const createAppointment = () => {
        // if (textValue == "") {
        //     toast.error('Please Enter video Url', {
        //         position: "top-center",
        //     });
        //     return;
        // }
        dispatch(setLoading(true))
        let body = {
            id: updateItem.id,
            link: textValue,
        }
        videoUplodeLink(body).then((data) => {
            dispatch(setLoading(false))
            if (data.data.status) {
                toast.success("Video Updated Successfully!!", {
                    position: "top-center",
                });
                // setTextValue("");
                // setUpdateItem(prev => ({
                //     ...prev,
                //     video_link: textValue, 
                //     }));
                
                 window.loadModal2('#UpdateVideo', 'hide')
                  handleVideoLinkChange(updateItem.id, textValue);
               
            }
            else {
                toast.error(data.data.message, {
                    position: "top-center",
                });
            }
        })
            .catch(() => { })

    }
    const cancelRequest = () => {

        window.loadModal2('#UpdateVideo', 'hide')
    }
    return (
        <div className="confirm-delete-wrapper register-medium">
            {console.log(updateItem)}
            <div
                className="modal fade "
                id="UpdateVideo"
                data-backdrop="static"
                role="dialog"
            >
                <div className="width-unset  modal-dialog advanceConfirmbooking modal-lg  modal-dialog-preview height-unset">
                    <div className="modal-content p-5">
                        <div className="modal-body">
                            <div className="">
                                <div className="schedule-popup">
                                    <h3 className="mb-4 mt-2 text-center mt-2">
                                        Upload Video
                                    </h3>
                                    <div>
                                        <div className="d-flex justify-content-between flex-column">
                                            <div className="from-fild mt-2 mb-4 text-left videoInputUrl">
                                                {/* <input
                                                    type="text"
                                                    value={textValue}
                                                    onChange={(e) => setTextValue(e.target.value)}
                                                    className="form-control p-2 w-100"
                                                    placeholder="Enter video URL"
                                                /> */}
                                                <textarea
                                                    value={textValue}
                                                    onChange={(e) => setTextValue(e.target.value)}
                                                    className="form-control p-2 w-100"
                                                    placeholder="Enter video URL"
                                                    rows={4}
                                                    />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="confirm-delete-wrapper ">
                                    <div className="confirm-btn-box">
                                        <div
                                            className="register-medium-confirnation model-close-btn"
                                            onClick={cancelRequest}
                                            data-dismiss="modal"
                                        >
                                            Cancel
                                        </div>
                                        <div
                                            className="register-medium-confirnation"
                                            // data-dismiss="modal"
                                            onClick={

                                                () => createAppointment()

                                            }
                                        >
                                            {updateItem.video_link ? "Update" : "Update"} 
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
